const DAY = 86400000;
export function ownerCurrentMonth(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Panama', year: 'numeric', month: '2-digit' }).format(now).replace(/^(\d{2})\/(\d{4})$/, '$2-$1');
}
function panamaToday(now) {
 const parts = new Intl.DateTimeFormat('en-US', { timeZone:'America/Panama',year:'numeric',month:'2-digit',day:'2-digit' }).formatToParts(now);
 const get = type => parts.find(p=>p.type===type).value;
 return Date.parse(`${get('year')}-${get('month')}-${get('day')}T00:00:00-05:00`);
}
export function shiftOwnerMonth(month, amount) {
 if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) throw new Error('Invalid month');
 const [year, m] = month.split('-').map(Number);
 const date = new Date(Date.UTC(year, m - 1 + amount, 1));
 return date.toISOString().slice(0,7);
}
export function ownerRangeBounds(key, now = new Date()) {
 const today = panamaToday(now), todayEnd = today + DAY;
 const month = key === 'month' ? ownerCurrentMonth(now) : key;
 if (/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) {
  const start = Date.parse(`${month}-01T00:00:00-05:00`);
  const end = Math.min(Date.parse(`${shiftOwnerMonth(month,1)}-01T00:00:00-05:00`),todayEnd);
  const previousStart=Date.parse(`${shiftOwnerMonth(month,-1)}-01T00:00:00-05:00`);
  const previousEnd=key === 'month' || month === ownerCurrentMonth(now) ? Math.min(start,previousStart+Math.max(0,end-start)) : start;
  return {start,end,previous:{start:previousStart,end:previousEnd}};
 }
 if(key==='all') return {start:0,end:todayEnd,previous:null};
 const days = {'7d':7,'30d':30,'90d':90}[key];
 if(!days) throw new Error('Invalid analytics range');
 const start=todayEnd-days*DAY;
 return {start,end:todayEnd,previous:{start:start-days*DAY,end:start}};
}
